export async function updateUserLocale({
  userId,
  locale,
  detectedLocale,
}: {
  userId: number;
  locale: string;
  detectedLocale: string;
}): Promise<Response> {
  try {
    const response = await fetch('/api/proxy/v3/users/updatelocale', {
      method: 'POST',
      credentials: 'same-origin',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({
        userId,
        locale,
        detectedLocale,
      }),
    });

    if (response.ok) return response.json();
    throw new Error('Unable to persist user locale');
  } catch (err) {
    throw new Error(err.message);
  }
}
